<template>
  <div>
    <!-- begin panel -->
    <panel no-button="true" title="Create new event">
      <p v-if="errors.length">Please correct the following error(s):</p>
      <ul>
        <li v-for="error in errors" :key="error" style="color: red">
          {{ error }}
        </li>
      </ul>
      <form>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-3">Event name</label>
          <div class="col-md-9">
            <input
              v-model="name"
              type="text"
              class="form-control m-b-5"
              placeholder="Enter event name"
            />
          </div>
        </div>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-3">Start date &amp; time</label>
          <div class="col-md-9">
            <date-picker
              v-model="startTime"
              :config="configs.start"
              ref="startDate"
              v-on:dp-change="onStartChange"
              placeholder="Start date and time">
            </date-picker>
          </div>
        </div>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-3">End date &amp; time</label>
          <div class="col-md-9">
            <date-picker
              v-model="endTime"
              :config="configs.end"
              ref="endDate"
              v-on:dp-change="onEndChange"
              placeholder="End date and time">
            </date-picker>
          </div>
        </div>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-3">Set up date &amp; time</label>
          <div class="col-md-9">
            <date-picker
              v-model="setupStartTime"
              :config="configs.setupStart"
              ref="setupStartDate"
              v-on:dp-change="onSetupStartChange"
              placeholder="Setup start date and time">
            </date-picker>
          </div>
        </div>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-3">Take down date &amp; time</label>
          <div class="col-md-9">
            <date-picker
              v-model="setupEndTime"
              :config="configs.setupEnd"
              ref="setupEndDate"
              v-on:dp-change="onSetupEndChange"
              placeholder="Setup end date and time">
            </date-picker>
          </div>
        </div>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-3">Description</label>
          <div class="col-md-9">
            <textarea
              v-model="description"
              class="form-control"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div
          v-for="(note, index) in notes"
          :key="index"
          class="form-group row m-b-15"
        >
          <label class="col-form-label col-md-3">Note #{{ index + 1 }}</label>
          <div class="col-md-8">
            <textarea v-model="note.content" class="form-control" rows="3" />
          </div>
          <div class="col-md-1">
            <b-button @click="openModal(index)" class="btn-danger pull-right"
              >Remove note</b-button
            >
          </div>
        </div>
        <div class="form-group row m-b-15">
          <div class="col-md-11" />
          <div class="col-md-1">
            <input-button
              type="button"
              label="Add note"
              @click="addNote"
              class="btn-inverse pull-right"
            />
          </div>
        </div>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-3">Picture</label>
          <div class="col-md-9">
            <vue-dropzone
              ref="imageDropzone"
              id="imageDropzone"
              :options="imageDropzoneOptions"
              @vdropzone-removed-file="imageRemoved"
              @vdropzone-success="imageSuccess"
            />
            <b-button variant="yellow" class="mt-2" @click="openImageLibrary"
              >Choose from library</b-button
            >
          </div>
        </div>
      </form>

      <hr />

      <b-button variant="secondary" @click="cancel">Cancel</b-button>
      <input-button
        type="submit"
        label="Save"
        @click="validate"
        class="btn-yellow pull-right"
      />

      <b-modal
        ref="modalAlert"
        :title="'Delete Note #' + (currentIndex + 1)"
        centered
        cancel-variant="white"
        ok-variant="danger"
        ok-title="Delete"
        v-on:ok="removeNote(currentIndex)"
      >
        <div class="alert alert-danger m-b-0">
          <h5><i class="fa fa-info-circle"></i>Delete</h5>
          <p>Are you sure you want to delete Note #{{ currentIndex + 1 }}?</p>
        </div>
      </b-modal>

      <image-library-modal ref="childModal" />
    </panel>
    <!-- end panel -->
  </div>
</template>

<script>
import InputButton from '../../components/buttons/InputButton.vue'
import ImageLibraryModal from '../image-library/ImageLibraryModal.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { authHeader } from '../../helpers'
import moment from 'moment'

export default {
  name: 'EventCreate',
  components: {
    InputButton,
    ImageLibraryModal,
    VueDropzone: vue2Dropzone
  },
  data() {
    return {
      errors: [],
      name: '',
      minTime: null,
      min: null,
      startTime: null,
      endTime: null,
      setupStartTime: null,
      setupEndTime: null,
      description: '',
      notes: [],
      currentIndex: 0,
      imageId: null,
      imageDropzoneOptions: {
        url: process.env.VUE_APP_API_URL + '/image',
        thumbnailWidth: 175,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        acceptedFiles: 'image/jpg, image/jpeg, image/png',
        dictDefaultMessage: 'Drop an image here to upload',
        headers: authHeader()
      },
      isDestroying: false,
      configs: {
        start: {
          format: 'DD.MM.YYYY HH:mm',
          useCurrent: false,
          showClear: true,
          showClose: true,
          sideBySide: true,
          minDate: false,
          maxDate: false
        },
        end: {
          format: 'DD.MM.YYYY HH:mm',
          useCurrent: false,
          showClear: true,
          showClose: true,
          sideBySide: true,
          minDate: false
        },
        setupStart: {
          format: 'DD.MM.YYYY HH:mm',
          useCurrent: false,
          showClear: true,
          showClose: true,
          sideBySide: true,
          minDate: false,
          maxDate: false
        },
        setupEnd: {
          format: 'DD.MM.YYYY HH:mm',
          useCurrent: false,
          showClear: true,
          showClose: true,
          sideBySide: true,
          minDate: false
        }
      }
    }
  },

  computed: {

  },

  methods: {

    addNote() {
      this.notes.push({ content: '' })
    },
    openModal(index) {
      this.currentIndex = index
      this.$refs['modalAlert'].show()
    },
    removeNote(index) {
      this.notes.splice(index, 1)
    },
    imageRemoved() {
      if (!this.isDestroying) {
        this.$parent.removeImage(this.imageId)
        this.imageId = null
      }
    },
    imageSuccess(imageFile, image) {
      this.imageId = image.id
    },
    imageSelected(image) {
      this.$refs.imageDropzone.removeAllFiles()
      this.imageId = image.id

      let mockFile = {
        id: this.imageId,
        size: 175,
        url: process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
      this.$refs.imageDropzone.manuallyAddFile(mockFile, mockFile.url)
    },
    openImageLibrary() {
      this.$refs['childModal'].$refs['modalImageLibrary'].show()
    },
    cancel() {
      if (this.imageId) {
        this.$parent.removeImage(this.imageId)
      }
      this.$router.push('/event')
    },
    validate() {
      if (this.name) {
        this.submit()
      }

      this.errors = []

      if (!this.name) {
        this.errors.push('Name required!')
      }
    },
    submit() {
      this.$parent.create(
        JSON.stringify({
          name: this.name,
          startTime: moment(this.startTime, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(this.endTime, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss'),
          setupTime: moment(this.setupStartTime, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss'),
          takeDownTime: moment(this.setupEndTime, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss'),
          description: this.description,
          notes: this.notes,
          imageId: this.imageId
        })
      )
      this.$router.push('/event')
    },
    onStartChange(e) {
      this.$set(this.configs.end, 'minDate', e.date || null)
    },
    onEndChange(e) {
      this.$set(this.configs.start, 'maxDate', e.date || null)
    },
    onSetupStartChange(e) {
      this.$set(this.configs.setupEnd, 'minDate', e.date || null)
    },
    onSetupEndChange(e) {
      this.$set(this.configs.setupStart, 'maxDate', e.date || null)
    },    
  },
  mounted() {
    this.minTime = new Date().toISOString().substr(0, 16)
    this.min = this.minTime
  },
  beforeDestroy() {
    this.isDestroying = true
  }
}
</script>
